import NoticeBanner from "./NoticeBanner";

export default NoticeBanner;
